export default class TouchPosition {
    /*
     */
    constructor(containerElement, sliderRadius, sliderTolerance) {
        this.containerElement = containerElement;
        this.sliderRadius = sliderRadius;
        this.sliderTolerance = sliderTolerance;
        this.setNewPosition({ x: 0, y: 0 });
    }

    /*
     */
    setNewPosition(e) {
        const dimensions = this.containerElement.getBoundingClientRect();
        const side = dimensions.width;
        this.center = side / 2;

        const localX = e.clientX - dimensions.left;
        const localY = e.clientY - dimensions.top;

        // NOTE: The knobs starting point has been changed to start at the top of the circle
        // hovever this is not done by some wild PI calculation or reflecting sine waves.
        // We are rotating the SVG generated by the slider and reversing the click
        // event coords so the interations look correct.
        this.relativeX = dimensions.width - localX;
        this.relativeY = dimensions.height - localY;
    }

    /*
     */
    get sliderAngle() {
        return (
            (Math.atan2(
                this.relativeY - this.center,
                this.relativeX - this.center
            ) +
                (Math.PI * 3) / 2) %
            (Math.PI * 2)
        );
    }

    /*
     */
    get isTouchWithinSliderRange() {
        const touchOffset = Math.sqrt(
            Math.pow(Math.abs(this.relativeX - this.center), 2) +
                Math.pow(Math.abs(this.relativeY - this.center), 2)
        );
        return (
            Math.abs(touchOffset - this.sliderRadius) <= this.sliderTolerance
        );
    }
}
